module.exports = __webpack_public_path__ + "img/鞋类设计创新不足.e0a31f1c.png";